import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLanguage } from '../../../../contexts/LanguageContext';

const VehicleWarrantyInfoDialog = ({ visible, onHide, chassisNo, items, isLoading, isError }) => {
    const { th } = useLanguage();

    return (
        <Dialog visible={visible} onHide={onHide} header={`${th('technicalSupport.warrantyInfoTitle')} — ${chassisNo}`} modal style={{ width: '90vw', maxWidth: '1100px' }}>
            {isLoading ? (
                <div className="flex justify-content-center align-items-center p-5" role="status" aria-label={th('common.loading')}>
                    <ProgressSpinner style={{ width: '3rem', height: '3rem' }} />
                </div>
            ) : isError ? (
                <div className="p-4 text-center p-error" role="alert">{th('technicalSupport.warrantyInfoError')}</div>
            ) : (
                <DataTable value={items} showGridlines emptyMessage={th('technicalSupport.noWarrantyInfo')} responsiveLayout="scroll">
                    <Column field="sasiNo" header={th('vehicleWarrantyInformation.columns.SasiNo')} />
                    <Column field="garantiTipi" header={th('vehicleWarrantyInformation.columns.GarantiTipi')} />
                    <Column field="strWarranty" header={th('vehicleWarrantyInformation.columns.StrWarranty')} />
                    <Column field="extWarranty" header={th('vehicleWarrantyInformation.columns.ExtWarranty')} />
                    <Column field="zMonth" header={th('vehicleWarrantyInformation.columns.ZMonth')} />
                    <Column field="mileage" header={th('vehicleWarrantyInformation.columns.Mileage')} />
                    <Column field="garantiBaslangic" header={th('vehicleWarrantyInformation.columns.GarantiBaslangic')} />
                    <Column field="garantiBitis" header={th('vehicleWarrantyInformation.columns.GarantiBitis')} />
                </DataTable>
            )}
        </Dialog>
    );
};

export default VehicleWarrantyInfoDialog;
